import { isAbortError } from "./isAbortError";

export async function processJsonStream<T>({
  stream,
  callbacks,
}: {
  stream: ReadableStream<Uint8Array>;
  callbacks: {
    onChunk: (chunk: T) => void;
    onDone?: () => void;
    onError?: (error: Error) => void;
  };
}): Promise<void> {
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  try {
    while (true) {
      const { value, done } = await reader.read();
      if (done) {
        const trimmedBuffer = buffer.trim();

        if (trimmedBuffer) {
          try {
            callbacks.onChunk(JSON.parse(trimmedBuffer));
          } catch (error) {
            callbacks.onError?.(error instanceof Error ? error : new Error(`Failed to parse JSON chunk`));
          }
        }

        break;
      }

      buffer += decoder.decode(value, { stream: true });
      let newlineIndex;

      while ((newlineIndex = buffer.indexOf("\n")) >= 0) {
        const line = buffer.substring(0, newlineIndex).trim();
        buffer = buffer.substring(newlineIndex + 1);

        if (line) {
          try {
            callbacks.onChunk(JSON.parse(line));
          } catch (error) {
            callbacks.onError?.(error instanceof Error ? error : new Error(`Failed to parse JSON chunk`));
          }
        }
      }
    }
    callbacks.onDone?.();
  } catch (streamError) {
    if (isAbortError(streamError)) {
      return;
    }

    callbacks.onError?.(streamError instanceof Error ? streamError : new Error("Stream reading failed."));
  } finally {
    reader.releaseLock();
  }
}
